import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/baseMessages/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/baseMessages/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/baseMessages/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/baseMessages/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/baseMessages/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/baseMessages/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/baseMessages/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
